import api, { MEETING_URL } from "./api";

/**
 *
 * @param {*} data
 * @returns
 */

export const updateTeacherWeeklySchedule = async (data) => {
  return await api.put(`${MEETING_URL}/schedule`, data);
};

/**
 *
 * @param {*} teacherId
 * @returns
 */
export const fetchTeacherSchedule = async (teacherId) => {
  return await api.get(`${MEETING_URL}/schedule/${teacherId}`);
};

/**
 *
 * @param {*} body
 * @returns
 */
export const fetchTeacherPerDaySlots = async (body) => {
  return await api.post(`${MEETING_URL}/slots`, body);
};

/**
 *
 * @param {*} body
 * @returns
 */
export const bookTeacherSlots = async (body) => {
  return await api.post(`${MEETING_URL}`, body);
};

/**
 *
 * @param {*} userID
 * @param {*} role
 * @returns
 */
export const fetchAllTeacherMeetings = async (userID, role) => {
  return await api.get(`${MEETING_URL}/${userID}/${role}`);
};

// /meetings/:userID/:roleID
